export const IOrderingAvailability = "OrderingAvailability";
